import React from "react"
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Button } from "@mui/material"
import { motion } from "framer-motion"
import CloseIcon from "@mui/icons-material/Close"

const DemoCTA = ({ open, onClose, calendlyLink }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          position: "relative",
          background: "var(--va-card-3)",
          boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "var(--va-main-bg)",
          color: "#fff",
          fontWeight: 700,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 18,
        }}
      >
        🚀 Ready to Boost Your Performance?
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", py: 5 }}>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            mb: 4,
            color: "var(--va-text-primary-color)",
            fontSize: 15,
            lineHeight: 1.6,
          }}
        >
          Unlock the full demo dashboard and schedule a 30-minute session to explore all features, see live data, and get expert guidance.
        </Typography>

        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} transition={{ type: "spring", stiffness: 300 }}>
          <Button
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #1a2bc2, #6e79d7)",
              color: "#fff",
              px: 5,
              py: 1.75,
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 3,
              textTransform: "none",
              boxShadow: "0 8px 20px rgba(26, 43, 194, 0.4)",
              "&:hover": {
                boxShadow: "0 12px 24px rgba(26, 43, 194, 0.5)",
              },
            }}
            onClick={() => window.open("https://calendly.com/farhan-prepaidrecon/30min", "_blank")}
          >
            Schedule Your Demo
          </Button>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}

export default DemoCTA
